import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import LoadingSvg from "@/assets/icons/loading.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchdButton',
  props: {
    tag: { default: "button" },
    variant: { default: "fill" },
    loading: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    disabled: _ctx.disabled,
    class: _normalizeClass(["btn relative overflow-hidden rounded-full font-medium text-xl py-3 px-6 xl:px-10 focus:outline-none focus:ring focus:ring-black focus:ring-opacity-50", [_ctx.variant, _ctx.size, _ctx.active ? 'active' : '']])
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_unref(LoadingSvg), { key: 0 }))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["disabled", "class"]))
}
}

})